import { usePaidMethodRecoilValue } from "@/shared/client";
import { FONT, RADIUS } from "@/styles/common";
import theme from "@/styles/theme";
import { Flex, Text } from "@chakra-ui/react";
import styled from "@emotion/styled";
import { RoomInfoProps } from "./roomInfo.type";

export const RoomInfo = ({ person, roomName, schedule, status }: RoomInfoProps) => {
    const { adult, child } = person;
    const { checkIn, checkOut } = schedule;
    const paidMethodValue = usePaidMethodRecoilValue();
    const paidMethodFromSessionStorage = sessionStorage.getItem("paidMethod");

    return (
        <Flex flexDir="column" gap="24px">
            <Flex columnGap="16px">
                <CustomRoomName fontSize="20px" fontWeight="700">
                    {roomName}
                </CustomRoomName>
                {status === "200" || status === "예약완료" ? (
                    <CustomFlex
                        backgroundColor={
                            paidMethodValue === "account" || paidMethodFromSessionStorage === "account"
                                ? theme.COLOR.pink[200]
                                : theme.COLOR.positive[100]
                        }
                    >
                        {paidMethodValue === "account" || paidMethodFromSessionStorage === "account"
                            ? "입금 대기"
                            : "예약 완료"}
                    </CustomFlex>
                ) : (
                    <CustomFlex backgroundColor={theme.COLOR.negative}>취소 완료</CustomFlex>
                )}
            </Flex>
            <Flex gap="4px" flexDir="column">
                <CustomText>
                    투숙 인원 : 성인 {adult}명 / 아동 {child}명 / 유아 0명
                </CustomText>
                <CustomText>
                    체크인/아웃 : {checkIn} ~ {checkOut}
                </CustomText>
            </Flex>
        </Flex>
    );
};

const CustomText = styled(Text)`
    color: ${({ theme }) => theme.COLOR.gray[500]};
`;

const CustomRoomName = styled(Text)`
    ${FONT("pretendard", 20, 700)}
`;

const CustomFlex = styled(Flex)`
    ${FONT("pretendard", 12, 300, 1.5)}
    padding:4px 8px;
    color: ${({ theme }) => theme.COLOR.white};
    box-sizing: border-box;
    ${RADIUS(2)}
    align-items: center;
`;
